exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider[data-v-83c190d6] {\n  margin: 0;\n  border: 1px solid #EEF2F6;\n}\n.divider[data-v-83c190d6]:last-of-type {\n  display: none;\n}", ""]);

// exports
